module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAT5JREFUKBWVUrtOwzAUxW6H/AEDe4Rggp2KrnmMmbKy8BUNK18AX4CqLIg81jCDSARTN5hZIoRClyTmXCuughQa15J1X+ccX1+b7XXLcZxzIcScQsZYFsfxY1faariqtm2bQaAFmcM+2La99Dxvour/WaYKlmWJNE1lTMSqqi5Qu4Hgt8IoiwPWwO5TPFXJvg3DsEF86/v+XT+v/LIsv5S/sZjBwSYYcfpY2TLuezXCGSwnSbKYgHyJO10DkWGLHfbCNM3PKee8wAu8QG2nLnCwS1xuGMYrOjgOgmBwoEO9d9gj1N44Jr7GU73neU4JrdVhP6Io+pEfCR0UTdOcaLEBIixxCC8F0EGBhLYAYYnzRwAJbQFgTzHAnATk4BA81XU9w2TvKTm20MEZRJ4JJz8SOa7rHsLQ1lkrDHBFwF+SWYxWuI9CYgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/folder.png
// module id = 1054
// module chunks = 0